import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { SectionService } from 'app/shared/services/section.service';
import { Constants } from '../constants/constants';
import { SectionRouteInformation } from '../models/section-routeinformation.model';

declare var $: any;

@Component({
  // moduleId: module.id,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {

  public menuItems: any[];
  homeRouterLink = Constants.DefaultStartPageUri;

  constructor(private router: Router, private route: ActivatedRoute, public authenticationService: AuthenticationService, public sectionService: SectionService) {
  }

  ngOnInit() {
    $.getScript('./assets/js/app-sidebar.js');

    // this.menuItems = ROUTES.filter(menuItem => menuItem);

    if (this.authenticationService.isAuthenticated && !this.authenticationService.isTwoFactorSetupActive) {
      this.sectionService.getCollection<SectionRouteInformation>('/section/permissions/view', null, (collection) => {
        this.menuItems = collection;
        if ((collection as SectionRouteInformation[]).length > 0) {
          this.homeRouterLink = (collection as SectionRouteInformation[])[0].path;
        }
      });
    }
  }
}
